import {checkDevice} from  '@/utils/checkDevice'
const mutations={
  setTest(state,value){
    state.test = value;
  },
  setMobile(state,value){
    state.isMobild=checkDevice();
  },
  increment (state) {
    state.count++
  },
  setChainId(state,payload) {
    state.chainId = payload;
  },
  setAccounts(state,payload){
    state.accounts = payload;
  },
  setSid(state,payload){
    state.sid = payload;
  },
  setProfileSid(state,payload){
    state.profileSid = payload;
  },
  setBalance(state,payload){
    state.balance = payload;
  },
  setReload(state,payload){
    state.isReload = payload;
  },
  setProvider(state,payload){
    state.provider = payload;
  },
}
export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js